module.exports = __webpack_public_path__ + "static/FUKUKOZY-bf4a4e23f10493ecc7ba05e4b614393a.jpeg";